import React from "react";

import * as Icon from "react-feather";

export const SidebarData = [
  {
    label: "All",
    submenuOpen: true,
    showSubRoute: false,
    submenuHdr: "Inventory",
    submenuItems: [
      {
        label: "Rank List",
        link: "/rank-list",
        icon: <Icon.Award />,
        showSubRoute: false,
        submenu: false
      },
      {
        label: "User List",
        link: "/user-list",
        icon: <Icon.Users />,
        showSubRoute: false,
        submenu: false
      },
      {
        label: "Token Config",
        link: "/token-config",
        icon: <Icon.FileText />,
        showSubRoute: false,
        submenu: false
      },
      {
        label: "Spinwheel",
        submenu: true,
        showSubRoute: false,
        icon: <Icon.FileText />,
        submenuItems: [
          {
            label: "Prize List",
            link: "/prize-list",
            icon: <Icon.Box />,
            showSubRoute: false,
            submenu: false,
          },
          {
            label: "Tier List",
            link: "/tier-list",
            icon: <Icon.PlusSquare />,
            showSubRoute: false,
            submenu: false,
          },
          {
            label: "Group Tier List",
            link: "/group-tier-list",
            icon: <Icon.Layers />,
            showSubRoute: false,
            submenu: false,
          },
          {
            label: "Spin History",
            link: "/spin-history",
            icon: <Icon.Clock />,
            showSubRoute: false,
            submenu: false
          },
          {
            label: "Spin Config",
            link: "/spin-config",
            icon: <Icon.Settings />,
            showSubRoute: false,
            submenu: false
          },
        ],
      },
    ],
  }
];
